import globals from 'Modules/globals';
import { scrollToElement } from '@openclassrooms/ui-web/scroll';

export const AUTO_SCROLL_TO_ANCHOR_DELAY = 500;

const { document } = globals;

function autoscrollToAnchor(delay = AUTO_SCROLL_TO_ANCHOR_DELAY) {
  const { hash } = document.location;
  const match = hash.match(/#\/id\/(.*)/);
  const id = match ? match[1] : null;

  if (!id) {
    return;
  }

  const element = document.getElementById(id);

  if (!element) {
    return;
  }

  setTimeout(() => {
    scrollToElement(element);
  }, delay);
}

export default autoscrollToAnchor;
